import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { all_routes } from 'core/data/routes/all_routes';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';
import { FaChevronDown, FaChevronUp, FaSearch } from 'react-icons/fa';
import './header.css'

export const MobileMenuButton = ({ isOpen, onClick }) => (
    <button 
        onClick={onClick} 
        className="mobile-menu-btn pe-0"
        aria-label={isOpen ? "Cerrar menú" : "Abrir menú"}
    >
        <span className={`hamburger ${isOpen ? "hamburger-active" : ''}`}>
            <span className="hamburger-bar"></span>
            <span className="hamburger-bar"></span>
            <span className="hamburger-bar"></span>
        </span>
    </button>
);

export const MobileMenu = ({ 
    isOpen, 
    onLinkClick, 
    menuItems, 
    searchQuery, 
    setSearchQuery, 
    handleMobileSearch, 
    searchResults, 
    showResults, 
    handleResultClick 
}) => {
    const [openSubMenus, setOpenSubMenus] = useState({});
    const contentRefs = useRef({});
    const location = useLocation();
    const searchInputRef = useRef(null);

    const toggleSubMenu = (key) => {
        setOpenSubMenus(prevState => ({
            ...prevState,
            [key]: !prevState[key]
        }));
    };

    const isActive = (item) => {
        if (location.pathname === item.link) {
            return true;
        }
        if (item.subMenu) {
            return item.subMenu.some(subItem => isActive(subItem));
        }
        return false;
    };

    useEffect(() => {
        if (isOpen && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [isOpen]);

    useEffect(() => {
        Object.keys(contentRefs.current).forEach(key => {
            if (contentRefs.current[key]) {
                const content = contentRefs.current[key];
                if (openSubMenus[key]) {
                    content.style.maxHeight = `1000px`;
                    content.style.opacity = '1';
                } else {
                    content.style.maxHeight = '0';
                    content.style.opacity = '0';
                }
            }
        });
    }, [openSubMenus]);

    const getValidPhoto = (result) => {
        if (result.product_option && result.product_option.length > 0) {
            const optionPhoto = result.product_option.find(option => option.url);
            if (optionPhoto) {
                return optionPhoto.url;
            }
        }
        if (result.photos && result.photos.length > 0) {
            return result.photos[0].src;
        }
        return null;
    };

    return (
        <div className={`mobile-menu-wrapper ${isOpen ? "mobile-menu-visible" : "mobile-menu-hidden"}`}>
            <nav className="mobile-nav">
                {isOpen && (
                    <div className="mobile-search-container">
                        <form method="get" className="w-100 header-search-2 mobile-search-form" style={{ maxHeight: '50px', maxWidth: '100%', padding: '20px 10px', position: 'relative' }} onSubmit={handleMobileSearch}>
                        <input
                            className="w-100"
                            type="text"
                            name="search"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Busca aquí"
                        />
                        <button onClick={() => {onLinkClick()}}  to={`${all_routes.product}?query=${searchQuery}`} className="search-mob" style={{ top: '50' }}>
                            <Link  to={`${all_routes.product}?query=${searchQuery}`}><i className="icon-search" /></Link>
                        </button>
                        {showResults && searchResults.length > 0 && (
                    <ul className="search-results scroll-light" style={{ position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: 'white', border: '1px solid #ccc', zIndex: 1000, maxHeight: '400px', overflowY: 'auto', margin: '20px' }}>
                        {searchResults.map(result => {
                            const photoUrl = getValidPhoto(result);
                            return (
                                <li key={result.id} style={{ padding: '10px', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <Link to={`${all_routes.productDetails}/${result.id}`} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit', width: '100%' }} onClick={handleResultClick}>
                                        {photoUrl && (
                                            <ImageWithBaseApi
                                                loadingIconFontSize="10"
                                                src={photoUrl}
                                                alt={result.title}
                                                style={{
                                                    width: '50px',
                                                    height: '50px',
                                                    marginRight: '10px',
                                                    objectFit: 'cover',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    textAlign: 'center'
                                                }}
                                            />
                                        )}
                                        <div style={{ flex: 1 }}>
                                            <h6 style={{ fontSize: '13px' }}>{result.title}</h6>
                                            <p className="mb-0" style={{ display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{result.description}</p>
                                        </div>
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                )}
                    </form>
                    </div>
                )}
                <ul className="mobile-nav-list">
                    {menuItems.map((item, index) => {
                        const menuKey = `menu-${index}`;
                        const hasSubMenu = item.subMenu && item.subMenu.length > 0;
                        
                        return (
                            <li
                                key={item.title}
                                className={`mobile-nav-item ${isActive(item) ? 'active' : ''} ${hasSubMenu ? 'has-submenu' : ''}`}
                            >
                                <div
                                    onClick={hasSubMenu ? () => toggleSubMenu(menuKey) : onLinkClick}
                                    className="mobile-nav-link-container"
                                >
                                    {item?.link?.startsWith('assets/') ? (
                                        <a
                                            href={item.link}
                                            className="mobile-nav-link"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {item.title}
                                        </a>
                                    ) : (
                                        <Link
                                            to={item.link}
                                            className="mobile-nav-link"
                                            onClick={hasSubMenu ? (e) => e.preventDefault() : null}
                                        >
                                            {item.title}
                                        </Link>
                                    )}
                                    {hasSubMenu && (
                                        <button 
                                            className="mobile-submenu-toggle"
                                            aria-expanded={openSubMenus[menuKey]}
                                        >
                                            {openSubMenus[menuKey] ? <FaChevronUp /> : <FaChevronDown />}
                                        </button>
                                    )}
                                </div>
                                {hasSubMenu && (
                                    <div
                                        className={`mobile-submenu ${openSubMenus[menuKey] ? 'open' : ''}`}
                                        ref={el => contentRefs.current[menuKey] = el}
                                    >
                                        <ul className="mobile-submenu-list">
                                            {item.subMenu.map((subItem, subIndex) => {
                                                const subMenuKey = `${menuKey}-sub-${subIndex}`;
                                                const hasSubSubMenu = subItem.subMenu && subItem.subMenu.length > 0;
                                                
                                                return (
                                                    <li
                                                        key={subItem.title}
                                                        className={`mobile-nav-item ${isActive(subItem) ? 'active' : ''} ${hasSubSubMenu ? 'has-submenu' : ''}`}
                                                    >
                                                        <div
                                                            onClick={hasSubSubMenu ? () => toggleSubMenu(subMenuKey) : onLinkClick}
                                                            className="mobile-nav-link-container"
                                                        >
                                                            {subItem.link.startsWith('assets/') ? (
                                                                <a
                                                                    href={subItem.link}
                                                                    className="mobile-nav-link"
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    {subItem.title}
                                                                </a>
                                                            ) : (
                                                                <Link
                                                                    to={subItem.link}
                                                                    className="mobile-nav-link"
                                                                    onClick={hasSubSubMenu ? (e) => e.preventDefault() : null}
                                                                >
                                                                    {subItem.title}
                                                                </Link>
                                                            )}
                                                            {hasSubSubMenu && (
                                                                <button 
                                                                    className="mobile-submenu-toggle"
                                                                    aria-expanded={openSubMenus[subMenuKey]}
                                                                >
                                                                    {openSubMenus[subMenuKey] ? <FaChevronUp /> : <FaChevronDown />}
                                                                </button>
                                                            )}
                                                        </div>
                                                        {hasSubSubMenu && (
                                                            <div
                                                                className={`mobile-submenu ${openSubMenus[subMenuKey] ? 'open' : ''}`}
                                                                ref={el => contentRefs.current[subMenuKey] = el}
                                                            >
                                                                <ul className="mobile-submenu-list">
                                                                    {subItem.subMenu.map((subSubItem, subSubIndex) => (
                                                                        <li
                                                                            key={subSubItem.title}
                                                                            className={`mobile-nav-item ${isActive(subSubItem) ? 'active' : ''}`}
                                                                        >
                                                                            <div
                                                                                onClick={onLinkClick}
                                                                                className="mobile-nav-link-container"
                                                                            >
                                                                                {subSubItem.link.startsWith('assets/') ? (
                                                                                    <a
                                                                                        href={subSubItem.link}
                                                                                        className="mobile-nav-link"
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                    >
                                                                                        {subSubItem.title}
                                                                                    </a>
                                                                                ) : (
                                                                                    <Link
                                                                                        to={subSubItem.link}
                                                                                        className="mobile-nav-link"
                                                                                    >
                                                                                        {subSubItem.title}
                                                                                    </Link>
                                                                                )}
                                                                            </div>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                )}
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </div>
    );
};